<template>
  <component :is="template" />
</template>

<script setup lang="ts">
import Default from '~/components/templates/Default.vue';
import Extended from '~/components/templates/Extended.vue';

definePageMeta({
  middleware: 'sofie-page',
  header: {
    transparent: true,
  },
});

const page = useSofiePage();

const template = computed(() => {
  if (page.value?.template_name === 'TemplateUitgebreid') {
    return Extended;
  } else {
    return Default;
  }
});
</script>
